import { render, staticRenderFns } from "./Ysbb.vue?vue&type=template&id=0af4c787&scoped=true&"
import script from "./Ysbb.vue?vue&type=script&lang=js&"
export * from "./Ysbb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4c787",
  null
  
)

export default component.exports